var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMoureWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151.318,
    height: 37.118,
    viewBox: "0 0 151.318 37.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_96",
    "data-name": "Rect\\xE1ngulo 96",
    width: 151.318,
    height: 37.118,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_197",
    "data-name": "Grupo 197",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109",
    "data-name": "Trazado 109",
    d: "M124.872,28.6a4.757,4.757,0,0,1-5.1,4.861,5.4,5.4,0,1,1-.088-10.793,5.22,5.22,0,0,1,4.534,2.468l-1.47.848a3.465,3.465,0,0,0-3.063-1.651,3.732,3.732,0,1,0,.1,7.463,3.124,3.124,0,0,0,3.361-2.378h-3.48V27.887h5.2Z",
    transform: "translate(-48.252 -9.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110",
    "data-name": "Trazado 110",
    d: "M139.076,27.922V29.66a1.965,1.965,0,0,0-2.289,2.083v3.746h-1.606V28.055h1.606V29.3a2.337,2.337,0,0,1,2.289-1.382",
    transform: "translate(-57.104 -11.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111",
    "data-name": "Trazado 111",
    d: "M150.492,28.152v7.434h-1.607v-.952a2.556,2.556,0,0,1-2.3,1.144,2.775,2.775,0,0,1-2.855-3.062V28.152h1.606v4.4A1.55,1.55,0,0,0,147,34.278c1.056,0,1.888-.625,1.888-2.142V28.152Z",
    transform: "translate(-60.714 -11.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_112",
    "data-name": "Trazado 112",
    d: "M166.594,31.728a3.789,3.789,0,0,1-3.7,3.91,3.086,3.086,0,0,1-2.6-1.248v4.029h-1.605V28.011h1.605v1.071a3.057,3.057,0,0,1,2.6-1.264,3.8,3.8,0,0,1,3.7,3.91m-1.605,0a2.35,2.35,0,1,0-2.35,2.378,2.3,2.3,0,0,0,2.35-2.378",
    transform: "translate(-67.033 -11.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_113",
    "data-name": "Trazado 113",
    d: "M174.18,31.728a3.925,3.925,0,1,1,3.926,3.91,3.88,3.88,0,0,1-3.926-3.91m6.245,0a2.319,2.319,0,1,0-2.319,2.35,2.282,2.282,0,0,0,2.319-2.35",
    transform: "translate(-73.578 -11.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_114",
    "data-name": "Trazado 114",
    d: "M200.436,33.411h-1.71v-7.42l-3.166,5.233h-.209l-3.167-5.248v7.434h-1.71V23h1.845l3.136,5.2,3.152-5.2h1.829Z",
    transform: "translate(-80.461 -9.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_115",
    "data-name": "Trazado 115",
    d: "M210.427,31.728a3.925,3.925,0,1,1,3.925,3.91,3.88,3.88,0,0,1-3.925-3.91m6.245,0a2.32,2.32,0,1,0-2.32,2.35,2.283,2.283,0,0,0,2.32-2.35",
    transform: "translate(-88.89 -11.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_116",
    "data-name": "Trazado 116",
    d: "M233.049,28.152v7.434h-1.605v-.952a2.558,2.558,0,0,1-2.3,1.144,2.775,2.775,0,0,1-2.854-3.062V28.152h1.605v4.4a1.55,1.55,0,0,0,1.665,1.725c1.055,0,1.889-.625,1.889-2.142V28.152Z",
    transform: "translate(-95.589 -11.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_117",
    "data-name": "Trazado 117",
    d: "M245.138,27.922V29.66a1.965,1.965,0,0,0-2.289,2.083v3.746h-1.606V28.055h1.606V29.3a2.337,2.337,0,0,1,2.289-1.382",
    transform: "translate(-101.907 -11.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_118",
    "data-name": "Trazado 118",
    d: "M252.792,34.167a2.268,2.268,0,0,0,1.918-.922l1.322.773a3.751,3.751,0,0,1-3.256,1.62,3.91,3.91,0,1,1-.118-7.819,3.75,3.75,0,0,1,3.732,3.924,4.74,4.74,0,0,1-.06.669h-5.917a2.235,2.235,0,0,0,2.379,1.754m1.976-3.063a2.067,2.067,0,0,0-2.125-1.829A2.161,2.161,0,0,0,250.4,31.1Z",
    transform: "translate(-105.071 -11.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_119",
    "data-name": "Trazado 119",
    d: "M62.429,37.118H41.879a.778.778,0,0,1-.673-.388L31.6,20.1,22,36.73a.778.778,0,0,1-.673.388H.777A.776.776,0,0,1,.1,35.953L20.655.359A.81.81,0,0,1,22,.359l9.6,16.634L41.206.359a.81.81,0,0,1,1.346,0L63.1,35.953a.776.776,0,0,1-.673,1.164m-20.1-1.553H61.085L41.879,2.3,32.5,18.545Zm-40.206,0H20.879l9.827-17.02L21.327,2.3Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMoureWhite);
export default __webpack_public_path__ + "static/media/logoMoureWhite.69e7cb7925a1ea391672c85153fee048.svg";
export { ForwardRef as ReactComponent };